import Seperator from "../../Atoms/Seperator";
import IconAndText from "../../Atoms/IconAndText";
import CustomButton from "../../Atoms/Buttons/CustomButton";
import DefineAgent from "./RegEditMolecules/DefineAgent";
import { useEffect } from "react";
import { useAgent } from "../../../contexts/AgentsContext";
import { useNavigate } from "react-router-dom";
import FooterSpacer from "../../Footer/FooterSpacer";
import DefineAgentVerProv from "./RegEditMolecules/DefineAgentVerProv";
import "../css/agent.form.css";
import DefineAgentClass from "./RegEditMolecules/DefineAgentClass";

const AgentForm = ({ title = "Submit", type, agentId }) => {
  const navigate = useNavigate();

  const {
    clearOngoingAgentData,
    registerAgent,
    isRegisteringOrEditingAgent,
    areAllRequiredFieldsValid,
    editAgent,
    isFetchingSectorsSilently,
    isLoadingDropdownFields
  } = useAgent();

  useEffect(() => {
    if (type === "register") {
      clearOngoingAgentData();
    }

    return () => {
      if (type === "register") {
        clearOngoingAgentData();
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (type === "edit") {
      try {
        await editAgent(agentId);
      } catch (err) {
        console.log("Agent Edit Error: ", err);
      }
    } else if (type === "register") {
      try {
        await registerAgent();
      } catch (err) {
        console.log("Agent Register Error: ", err);
      }
    }

  };

  const handleCancel = (e) => {
    e.preventDefault();

    navigate("/agents");
  };


  const checkLookupLoadings = () => {
    for (let key in isLoadingDropdownFields) {
      if (isLoadingDropdownFields[key]) {
        return true;
      }
    }
    return false;
  };

  return (
    <article className="mas-agent-form-container">
      {/* Buttons */}
      <section className="mas-agent-form-header">
        <div className="mas-agent-form-btns">
          <h4 className="heading-4 fw-bold">{title}</h4>
          <div className="btns d-flex gap-2">
            <CustomButton
              label="Cancel"
              clsNames="mas-secondary-btn-2 mas-btn-med"
              onClickFn={handleCancel}
              disabled={isRegisteringOrEditingAgent}
            />
            <CustomButton
              label={`${type === "register" ? "Register" : "Save"}`}
              clsNames="mas-primary-btn mas-btn-med"
              onClickFn={handleSubmit}
              disabled={
                !areAllRequiredFieldsValid() || isRegisteringOrEditingAgent || checkLookupLoadings() ||
                isFetchingSectorsSilently
              }
            />
          </div>
        </div>
        <Seperator
          clsNames={
            "mas-horizontal-seperator-100 marketplace-horizontal-seperator-wd"
          }
          styles={{
            backgroundColor: "var(--db-secondary-gray-seven)",
            padding: "0 48px",
          }}
        />
      </section>

      {/* Content */}
      <section className="mas-agent-form-content">
        <section className="items">
          <div id="define-agent" className="mb-5">
            <IconAndText
              text="Define Agent"
              clsNames="mas-icon-txt mb-2"
              iconBefore={<div>{"1"}</div>}
            />

            <DefineAgent />
          </div>

          <div id="version-provider" className="mb-5">
            <IconAndText
              text="Define Version and Provider"
              clsNames="mas-icon-txt mb-2"
              iconBefore={<div>{"2"}</div>}
            />

            <DefineAgentVerProv />
          </div>

          <div id="classification-sec mb-3">
            <div className="d-flex align-items-center mb-3">
              <IconAndText
                text="Define Classification"
                clsNames="mas-icon-txt"
                iconBefore={<div>{"3"}</div>}
              />
            </div>
            {/* <DefineAgentClassification type={type} /> */}
          </div>
          <DefineAgentClass type={type} />
        </section>
      </section>

      <FooterSpacer
        styles={{ height: "calc(var(--db-footer-height) + 75px)" }}
      />
    </article>
  );
};

export default AgentForm;
